/**
 * 获取静态资源链接
 */
export const getAssetsFile = function (url) {
  return new URL(`../assets/${url}`, import.meta.url).href
}

/**
 * 生成对应字符长度的随机id
 */
export function generateRandomId(length = 10) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * 生成一个唯一的id，重复的概率很小
 * @return {string}
 */
export function generateUniqueId() {
  return Date.now() + '' + Math.random().toString(36).slice(2)
}

/**
 * 格式化价格
 * @param price
 */
export function filterPrice(price) {
  return parseFloat(parseFloat(price).toFixed(2))
}

/**
 * 根据关键字过滤列表
 * @param {Object} item
 * @param {Array} regexMatchFields
 * @param {Array} matchFields
 * @param {string} keyword
 * @returns {boolean}
 */
export function filterFunction(item, regexMatchFields, matchFields, keyword) {
  if (!item) {
    return false
  }
  // 模糊匹配
  for (const field of matchFields) {
    if (item[field].toLowerCase().includes(keyword.toLowerCase())) {
      return true
    }
  }

  // 正则匹配
  for (const field of regexMatchFields) {
    const words = Array.from(keyword.toLowerCase())
    const pattern = new RegExp(words.join('.*'), 'i')
    if (pattern.test(item[field].toLowerCase())) {
      return true
    }
  }

  return false
}
